module.exports = __webpack_public_path__ + "static/media/addition-achivment-icon.066c0c34.svg";